"use strict";

exports.__esModule = true;
var createOnFocus = function createOnFocus(name, focus) {
  return function () {
    return focus(name);
  };
};
exports["default"] = createOnFocus;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/events/createOnFocus.js
 ** module id = 578
 ** module chunks = 0
 **/